import React from 'react'
import {Popover, PopoverHeader, PopoverBody} from 'reactstrap'
import moment from 'moment'
import DayPicker, {DateUtils} from 'react-day-picker'
import _capitalize from 'lodash/capitalize'
import MomentLocaleUtils from 'react-day-picker/moment'
import 'moment/locale/ro'
import 'moment/locale/de'
import 'moment/locale/fr'
import 'moment/locale/it'
import 'moment/locale/es'

export default class DaySelect extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            date: moment(this.props.date).toDate(),
            months: window.innerWidth > 550 ? 2 : 1,
            locale: this.props.locale || 'en'
        }
        moment.locale(this.props.locale || 'en')
    }

    formatDate(date) {
        return (
            <React.Fragment>
                <span className="d-lg-none d-xl-inline">{_capitalize(moment(date).format('ddd, '))}</span>
                {moment(date).format('DD ')}
                {_capitalize(moment(date).format('MMMM'))}
            </React.Fragment>
        )
    }

    handleChange = (date) => {
        this.setState({date: date, open: false})
        this.props.onDayChange && this.props.onDayChange(date)
    }

    togglePick = () => {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        return (
            <span id={this.props.id} onClick={this.togglePick} style={{cursor: 'pointer'}}>
                        <i className={'fa fa-calendar text-primary mr-1 mt-2'}/>{this.formatDate(this.state.date)}
                <Popover placement="bottom-start" isOpen={this.state.open} target={this.props.id}
                         toggle={this.togglePick} trigger="legacy">
                            <PopoverHeader className={'bg-primary text-white text-center'}>
                                Select Date
                            </PopoverHeader>
                            <PopoverBody onClick={(e) => e.stopPropagation()}>
                                <DayPicker
                                    disabledDays={{before: new Date()}}
                                    month={this.state.date}
                                    fromMonth={moment().toDate()}
                                    numberOfMonths={this.state.months}
                                    onDayClick={this.handleChange}
                                    locale={this.state.locale}
                                    localeUtils={MomentLocaleUtils}
                                    selectedDays={[this.state.date]}
                                />
                            </PopoverBody>
                        </Popover>
                    </span>
        )
    }
}